import { css } from '@emotion/core';
export default {
  name: "1fclaxo",
  styles: "max-width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
};